(function () {
  'use strict';

  var preferred = '';
  var storedMode = '';
  try {
    preferred = window.sessionStorage.getItem('sfYmmPreferredCategory') || '';
    storedMode = window.sessionStorage.getItem('sfCatalogModeV1') || '';
  } catch (_error) {
    return;
  }

  var url = new URL(window.location.href);
  var requestedView = url.searchParams.get('view');
  if (
    requestedView === 'senfineco-spare-parts' ||
    requestedView === 'senfineco-consumables'
  ) return;

  var mode = storedMode === 'consumables' || preferred === 'filters'
    ? 'consumables'
    : storedMode === 'spare_parts' || preferred === 'parts'
      ? 'spare_parts'
      : '';
  if (!mode) return;
  if (!/\/collections\/all\/[^/?]*(?:esi|esr)\d+$/i.test(url.pathname)) return;

  var tag = decodeURIComponent(url.pathname.split('/').filter(Boolean).pop() || '');
  var match = tag.match(/^([a-z]+)-(.+?)-((?:19|20)\d{2})-((?:19|20)\d{2})-(?:esi|esr)\d+$/i);
  if (match) {
    try {
      var existing = JSON.parse(window.localStorage.getItem('sfSparePartsVehicleV1') || 'null');
      if (!existing || !existing.label) {
        var titleize = function (value) {
          return String(value || '')
            .split('-')
            .filter(Boolean)
            .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
            .join(' ');
        };
        var vehicle = {
          version: 2,
          source: 'easysearch',
          providerVehicleId: 'easysearch:' + tag,
          make: titleize(match[1]),
          model: titleize(match[2]),
          year: match[3] + '–' + match[4],
          engine: '',
          values: [],
          updatedAt: new Date().toISOString()
        };
        vehicle.label = [vehicle.make, vehicle.model, vehicle.year].filter(Boolean).join(' · ');
        window.localStorage.setItem('sfSparePartsVehicleV1', JSON.stringify(vehicle));
      }
    } catch (_error) {
      /* The filtered page remains usable when persistent storage is unavailable. */
    }
  }

  url.searchParams.set(
    'view',
    mode === 'consumables' ? 'senfineco-consumables' : 'senfineco-spare-parts'
  );
  window.location.replace(url.pathname + url.search + url.hash);
})();